"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaSelect = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const AreaSelectWrapper = styled_components_1.default.div `
  margin-top: 25px;
`;
const FieldValidationError = styled_components_1.default.div `
  color: red;
  font-style: italic;
  div::first-letter {
    text-transform: uppercase;
  }
`;
const getPreselectedValue = options => {
    const selectedValue = options.find(option => option.selected);
    return selectedValue || options[0];
};
const getValueBasedOnId = (option, useId) => {
    return useId ? option.id : option.label;
};
const AreaSelect = (props) => {
    const { fieldData, onChange, usePreselectedValue, useId } = props;
    const [value, setValue] = (0, react_1.useState)(() => {
        const preselectedOption = usePreselectedValue ? getPreselectedValue(fieldData.options) : fieldData.options[0];
        return getValueBasedOnId(preselectedOption, useId);
    });
    (0, react_1.useEffect)(() => {
        onChange(fieldData, value);
    }, []);
    const handleChange = event => {
        const newValue = event.target.value;
        setValue(newValue);
        onChange(fieldData, newValue);
    };
    return (react_1.default.createElement(AreaSelectWrapper, { className: fieldData.errors && fieldData.errors.length > 0 ? 'field-error' : '' },
        react_1.default.createElement(material_1.FormControl, { fullWidth: true },
            react_1.default.createElement(material_1.InputLabel, { id: fieldData.label }, fieldData.mandatory ? `${fieldData.label} *` : fieldData.label),
            react_1.default.createElement(material_1.Select, { labelId: fieldData.label, id: "area-select", value: value, label: fieldData.label, onChange: handleChange, disabled: fieldData.disabled || false, required: fieldData.mandatory }, fieldData.options.map(option => (react_1.default.createElement(material_1.MenuItem, { key: option.id, value: useId ? option.id : option.label, "data-id": option.id, "data-selected": option.selected }, option.label))))),
        react_1.default.createElement(FieldValidationError, null, fieldData.errors.map(error => (react_1.default.createElement("div", { key: (0, react_uid_1.uid)(error) }, error))))));
};
exports.AreaSelect = AreaSelect;
exports.default = exports.AreaSelect;
